import { 
  Stack, 
  Title, 
  Text, 
  Paper, 
  Group, 
  Badge, 
  Table, 
  ThemeIcon, 
  SimpleGrid,
  Box,
  Tooltip
} from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { TbCreditCard, TbCheck, TbAlertCircle, TbWallet, TbHistory, TbArrowUpRight, TbCircleCheck, TbRefresh } from 'react-icons/tb'
import { StatsCard } from '@/frontend/components/StatsCard'

export const Route = createFileRoute('/apps/$appId/payments')({
  component: PaymentsPage,
})

const mockPayments = [
  { id: 'TRX-8412', method: 'Credit Card (Visa)', amount: 'Rp 2.450.000', status: 'SUCCESS', date: '2026-04-01 14:30', gateway: 'Stripe' },
  { id: 'TRX-8413', method: 'BCA Virtual Account', amount: 'Rp 1.150.000', status: 'PENDING', date: '2026-04-01 14:28', gateway: 'Midtrans' },
  { id: 'TRX-8414', method: 'OVO / E-Wallet', amount: 'Rp 450.000', status: 'SUCCESS', date: '2026-04-01 14:25', gateway: 'Midtrans' },
  { id: 'TRX-8415', method: 'ShopeePay', amount: 'Rp 890.000', status: 'FAILED', date: '2026-04-01 14:20', gateway: 'Midtrans' },
  { id: 'TRX-8416', method: 'Mandiri Transfer', amount: 'Rp 3.200.000', status: 'SUCCESS', date: '2026-04-01 14:15', gateway: 'Bank Sync' },
]

const gateways = [
  { name: 'Stripe', status: 'Operational', color: 'teal' },
  { name: 'Midtrans', status: 'Operational', color: 'teal' },
  { name: 'Bank Sync', status: 'Slow Response', color: 'orange' },
]

function PaymentsPage() {
  return (
    <Stack gap="xl">
      <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="lg">
        <StatsCard title="Total Volume" value="Rp 842.5M" icon={TbWallet} color="brand-blue" trend={{ value: '12.4%', positive: true }} />
        <StatsCard title="Success Rate" value="98.2%" icon={TbCircleCheck} color="teal" />
        <StatsCard title="Refunds (30d)" value="Rp 4.2M" icon={TbHistory} color="red" />
      </SimpleGrid>

      <Group justify="space-between" align="center">
        <Stack gap={0}>
          <Title order={3}>Payment Gateway Health</Title>
          <Text size="sm" c="dimmed">Real-time status monitoring for integrated payment providers.</Text>
        </Stack>
      </Group>

      <SimpleGrid cols={{ base: 1, md: 3 }} spacing="lg">
        {gateways.map((gw) => (
          <Paper key={gw.name} withBorder radius="xl" p="md" className="glass">
            <Group justify="space-between">
              <Group gap="xs">
                <ThemeIcon variant="light" color={gw.color} radius="md" size="lg">
                  <TbRefresh size={24} />
                </ThemeIcon>
                <Text fw={600} size="sm">{gw.name}</Text>
              </Group>
              <Badge color={gw.color} variant="dot">{gw.status}</Badge>
            </Group>
          </Paper>
        ))}
      </SimpleGrid>

      <Stack gap="xs">
        <Title order={4} mt="md">Recent Transactions</Title>
        <Paper withBorder radius="2xl" className="glass" p="md">
          <Table className="data-table" verticalSpacing="md" highlightOnHover>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Transaction ID</Table.Th>
                <Table.Th>Method</Table.Th>
                <Table.Th>Gateway</Table.Th>
                <Table.Th>Amount</Table.Th>
                <Table.Th>Status</Table.Th>
                <Table.Th>Timestamp</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {mockPayments.map((trx) => (
                <Table.Tr key={trx.id}>
                  <Table.Td>
                    <Group gap="xs">
                      <TbArrowUpRight size={14} color="gray" />
                      <Text fw={600} size="sm">{trx.id}</Text>
                    </Group>
                  </Table.Td>
                  <Table.Td>
                    <Group gap="xs">
                      <TbCreditCard size={14} color="gray" />
                      <Text size="sm">{trx.method}</Text>
                    </Group>
                  </Table.Td>
                  <Table.Td>
                    <Badge variant="default" radius="sm">{trx.gateway}</Badge>
                  </Table.Td>
                  <Table.Td>
                    <Text fw={700} size="sm" color="brand-blue">{trx.amount}</Text>
                  </Table.Td>
                  <Table.Td>
                    <Badge 
                      color={trx.status === 'SUCCESS' ? 'teal' : trx.status === 'PENDING' ? 'orange' : 'red'} 
                      variant={trx.status === 'SUCCESS' ? 'light' : 'outline'}
                      leftSection={trx.status === 'SUCCESS' ? <TbCheck size={12} /> : <TbAlertCircle size={12} />}
                      radius="sm"
                    >
                      {trx.status}
                    </Badge>
                  </Table.Td>
                  <Table.Td>
                    <Text size="xs" c="dimmed">{trx.date}</Text>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Paper>
      </Stack>
    </Stack>
  )
}
